import { useEffect, useRef } from 'react';
import { MAP_DEFAULT_CENTER, MAP_DEFAULT_ZOOM } from './mapLeafletHelper';

declare var L: any;

export function useMapInstance(onInteraction?: () => void) {
  const mapDivRef = useRef<HTMLDivElement>(null);
  const mapInstance = useRef<any>(null);
  const markersClusterRef = useRef<any>(null);
  const onInteractionRef = useRef(onInteraction);
  onInteractionRef.current = onInteraction;

  useEffect(() => {
    if (mapDivRef.current && !mapInstance.current && typeof L !== 'undefined') {
      const map = L.map(mapDivRef.current).setView(MAP_DEFAULT_CENTER, MAP_DEFAULT_ZOOM);
      L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap',
      }).addTo(map);

      mapInstance.current = map;
      
      const fireInteraction = () => {
        onInteractionRef.current?.();
      };
      map.on('mousedown movestart zoomstart', fireInteraction);

      markersClusterRef.current = L.markerClusterGroup({
        showCoverageOnHover: false,
        zoomToBoundsOnClick: true,
        spiderfyOnMaxZoom: true,
        chunkedLoading: true,
        maxClusterRadius: 80,
      });
      map.addLayer(markersClusterRef.current);
      setTimeout(() => map.invalidateSize(), 250);
    }

    return () => {
      if (mapInstance.current) {
        mapInstance.current.remove();
        mapInstance.current = null;
      }
    };
  }, []);

  return { mapDivRef, mapInstance, markersClusterRef };
}
